import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ActionInterface } from "../../Interface/ActionInterface";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";
import AgencyFeeFactory from "../../Entity/Factories/AgencyFeeFactory";

export default function* agencyFeeList(action: ActionInterface): any {
  try {

    const res = yield call(Http.get, "agency-fees");

    const agencyFees = res.data.map(agencyFee => {
      return AgencyFeeFactory.create(agencyFee);
    });

    yield put({
      type: Constants.GLOBAL_AGENCY_FEE_LIST_SUCCESS,
      payload: {
        agencyFees: agencyFees
      }
    });

  } catch (err) {
    // should signout user if entity could not be loaded
    yield put({
      type: Constants.PAGE_SIGNOUT_START
    });
    
    yield ErrorHandlerSequence(err, action);
  }
}

export function* watchAgencyFeeList() {
  yield takeEvery(Constants.GLOBAL_AGENCY_FEE_LIST, agencyFeeList);
}
